import { useState } from "react";

import { FeedbackStars } from "../../../components/FeedbackStars.tsx";
import { WHATS_NEW_EVENT } from "../../whatsNew/WhatsNewModal.tsx";
import { PrivacyPolicyModal } from "./PrivacyPolicyModal.tsx";
import { TermsOfUseModal } from "./TermsOfUseModal.tsx";

export const APP_VERSION = "2.19.0";

const LINK_BUTTON_STYLE = {
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  color: "inherit",
  textDecoration: "underline",
  font: "inherit",
} as const;

export function AppFooter() {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <footer
      style={{
        marginTop: 32,
        padding: "14px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        fontSize: 12.5,
        color: "var(--text-2)",
        borderTop: "1px solid var(--border-soft)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: 14,
        }}
      >
        <span>
          <span className="mono">v{APP_VERSION}</span>
          <span style={{ margin: "0 6px" }}>·</span>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event(WHATS_NEW_EVENT))}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              color: "inherit",
              textDecoration: "underline",
              font: "inherit",
            }}
          >
            What's new
          </button>
          <span style={{ margin: "0 6px" }}>·</span>
          <a
            href="https://sellsynq.com"
            target="_blank"
            rel="noreferrer"
            style={{ color: "inherit", textDecoration: "none", fontWeight: 500 }}
          >
            sellsynq.com
          </a>
        </span>
        <FeedbackStars />
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
        <button type="button" onClick={() => setTermsOpen(true)} style={LINK_BUTTON_STYLE}>
          Terms of Use
        </button>
        <span style={{ color: "var(--text-3)" }}>·</span>
        <button type="button" onClick={() => setPrivacyOpen(true)} style={LINK_BUTTON_STYLE}>
          Privacy Policy
        </button>
      </div>

      <TermsOfUseModal open={termsOpen} onClose={() => setTermsOpen(false)} />
      <PrivacyPolicyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </footer>
  );
}
